import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { ON_FETCH_FAILURE, ON_FETCH_START, CLEAR_ERRORS, FETCH_CARTS_FAILURE, ADD_TO_CARTS_FAILURE, MERGE_CARTS_FAILURE } from '@nike/cart-constants';

// NOTE: another example relocated file if team wants to
// break up ../reducer.js into separate reducer files
// NOTE: might need to be an array - obj could be complex due to dynamic key(s)

var errorReducer = function errorReducer() {
  var _action$payload, _action$payload2, _action$payload3, _action$payload3$erro, _action$payload4, _action$payload5, _action$payload6;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case MERGE_CARTS_FAILURE:
    case FETCH_CARTS_FAILURE:
    case ADD_TO_CARTS_FAILURE:
    case ON_FETCH_FAILURE:
      return [].concat(_toConsumableArray(state), [{
        code: action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.code,
        error: action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.error,
        message: action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : (_action$payload3$erro = _action$payload3.error) === null || _action$payload3$erro === void 0 ? void 0 : _action$payload3$erro.message,
        crcCode: action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.crcCode,
        field: action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.field,
        items: action === null || action === void 0 ? void 0 : (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.itemsRemoved
      }]);
    case ON_FETCH_START:
    case CLEAR_ERRORS:
      return [];
    default:
      return state;
  }
};
export default errorReducer;